<template>
  <div class="card is-gray">
    <div class="card-content">
      <p class="title is-5">{{ $props.statTitle }}</p>
      <p class="subtitle is-6">{{ $props.statSubtitle }}</p>
      <p class="title has-text-centered">
        <b-loading v-model="isLoading" :is-full-page="false" />
        <span
          v-if="dataState === 'done'"
          :title="formatWithCommas(programStatData)"
        >
          {{ formatValue(programStatData) }}
        </span>
        <span v-if="dataState === 'error'">Failed to load</span>
      </p>
    </div>
  </div>
</template>

<script>
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";
import { mapActions } from "vuex";

export default {
  name: "ProgramStatItem",
  mixins: [numberUtilityMixin],

  props: {
    programId: {
      type: Number,
      required: true
    },
    statType: {
      type: String,
      required: true
    },
    statTitle: {
      type: String,
      required: true
    },
    statSubtitle: {
      type: String,
      required: false,
      default: ""
    }
  },

  data() {
    return {
      isLoading: true,
      dataState: "loading",
      programStatData: 0
    };
  },

  async mounted() {
    await this.fetchStatData();
  },

  methods: {
    ...mapActions("program", ["fetchHealthData"]),

    async fetchStatData() {
      try {
        const payload = {
          programId: this.$props.programId,
          statType: this.$props.statType
        };

        this.fetchHealthData(payload)
          .then(data => {
            this.programStatData = data.stats;
          })
          .catch(e => {
            console.error(e);

            this.dataState = "error";
          });

        this.dataState = "done";
      } catch (e) {
        this.dataState = "error";

        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    formatValue(value) {
      // if the value is less than a million, format the number.
      if (value < 1000000) {
        return this.formatWithCommas(this.programStatData);
      }

      // larger numbers look awful, let's just provide a cleaned-up version.
      return this.shorthandCounter(this.programStatData);
    }
  }
};
</script>

<style scoped lang="sass">
.card.is-gray
  background-color: $grey-lighter
</style>
